<script setup lang="ts">
import Loading from "@/components/shared/Loading.vue";
defineOptions({ inheritAttrs: false });
const type = ["heading"];
</script>

<template>
  <div>
    <Loading :typeLoading="type"></Loading>
  </div>
</template>
